import React from 'react';

export default function NavigationBar({ children }) {
    return (
        <div
            data-collapse="none"
            data-animation="default"
            data-duration={400}
            id="top"
            className="top-nav white w-hidden-small w-hidden-tiny"
        >
            <div className="berlin-row w-hidden-tiny">
                <div className="div-block-2 w-hidden-small w-hidden-tiny w-clearfix">
                    {children}
                </div>
            </div>
        </div>
    );
}
